const getRetinalExamDataModelConfig = () => {
  return {
    deviceDataModelId: import.meta.env.VITE_DEVICE_MODEL_ID,
    devicePropertySetId: import.meta.env
      .VITE_DEVICE_PROPERTY_SET_ID_EXAM_SUBMISSION,
  };
};

export default getRetinalExamDataModelConfig;
